import TaskCard from './TaskCard';
export {
  ITaskCardProps,
  StatusType
} from './common';

export default TaskCard;
